import React, { useEffect, useState } from 'react';

import UserInfo from 'ui/user/UserInfo';
import BackupsImg from '../../../images/backups-165x165.png';
import { Button, Typography, Grid } from '@material-ui/core';
import Dashboard from 'ui/dashboard/Dashboard';
import DashboardBox from 'ui/dashboard/Box';
import DashboardBoxContent from 'ui/dashboard/BoxContent';
import DashboardBoxActions from 'ui/dashboard/BoxActions';
import { MTable } from 'ui/mtable/MTable';
import { withCompanyContext } from '../CompanyContext';
import { createDetailRender } from './DetailRender';

import { loadBackupsUsers } from '../Services';
import { loadPolices } from '../policies/services';

function BackupsTab({ company, editable, history }) {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [enabled, setEnabled] = useState(true);

    useEffect(() => {
        loadPolices(company.id).then(({ policies }) => {
            const policy =
                policies.find(
                    policy => policy.policy.identifier === 'POLICY-009'
                ) || {};
            setEnabled(policy.enabled || false);
            if (policy.enabled) {
                loadBackupsUsers(company.id).then(users => {
                    setUsers(users);
                    setLoading(false);
                });
            } else {
                setLoading(false);
            }
        });
    }, []);

    return (
        <>
            {enabled && (
                <MTable
                    stateKey="Backups"
                    columns={getTableColumns()}
                    data={users}
                    loading={loading}
                    title={null}
                    detailPanel={[
                        {
                            icon: () => <div />,
                            openIcon: () => <div />,
                            render: rowData => {
                                const Component = createDetailRender(
                                    company,
                                    editable
                                );
                                return <Component row={rowData} />;
                            },
                        },
                    ]}
                    onRowClick={(event, rowData, togglePanel) => togglePanel()}
                />
            )}
            {!enabled && (
                <Dashboard width="70" align="center">
                    <DashboardBox>
                        <DashboardBoxContent>
                            <Grid container spacing={3} direction="row">
                                <Grid item xs="auto">
                                    <img src={BackupsImg} alt="backups" />
                                </Grid>
                                <Grid item xs>
                                    <Grid
                                        container
                                        justify="center"
                                        direction="column"
                                        style={{ height: '100%' }}
                                    >
                                        <Typography variant="h5" gutterBottom>
                                            Backup passwords and notes from your
                                            users to prevent loss of data
                                        </Typography>
                                        <Typography
                                            color="textSecondary"
                                            variant="body1"
                                            gutterBottom
                                        >
                                            Backup are configured within
                                            Security Policy on the Policies tab.
                                            Once backups are enabled, the
                                            CyberFOX Password Manager app on
                                            each users device will start
                                            perfoming backups.
                                        </Typography>
                                        <Typography
                                            color="textSecondary"
                                            variant="body1"
                                            gutterBottom
                                            style={{ marginBottom: 24 }}
                                        >
                                            After the backups have started you
                                            will start to see them on this tab.
                                        </Typography>
                                        <Typography
                                            color="textSecondary"
                                            variant="subtitle2"
                                            gutterBottom
                                        >
                                            Backups are avaliable to companies
                                            with an Advanced or Trial
                                            subscription
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </DashboardBoxContent>
                        <DashboardBoxActions>
                            <Button
                                color="secondary"
                                onClick={() =>
                                    history.push(
                                        `/companies/${company.id}/policies`
                                    )
                                }
                            >
                                CONFIGURE BACKUPS
                            </Button>
                        </DashboardBoxActions>
                    </DashboardBox>
                </Dashboard>
            )}
        </>
    );
}

const getTableColumns = () => [
    {
        field: 'uuid',
        title: 'Uuid',
        export: false,
        notFilter: true,
        hidden: true,
        cellStyle: {
            width: '5%',
        },
    },
    {
        field: 'email',
        title: 'User',
        render: row => <UserInfo user={row} />,
        cellStyle: {
            width: '40%',
        },
    },
    {
        field: 'groups',
        title: 'Groups',
        render: val => {
            const names = val.groups.map(group => group.name).join(', ');
            return <span>{names}</span>;
        },
        exportValue: val => val.map(group => group.name).join(', '),
        cellStyle: {
            width: '55%',
        },
    },
];

export default withCompanyContext(BackupsTab);
